import { axiosClient } from 'www/utils'
import type {
  ApiPhoneSendConfirmationCodePostParams,
  ApiPhoneSendConfirmationCodePostResponse,
} from 'www/vue_components/common/UserAuthorization/api/apiPhoneSendConfirmationCode.types'

export default {
  post(data: ApiPhoneSendConfirmationCodePostParams) {
    return axiosClient.post<ApiPhoneSendConfirmationCodePostResponse>(
      '/ajax/phone_send_confirmation_code/',
      data,
      {
        withCredentials: true,
      },
    )
  },
}
